<template>
  <div class="column">
    <div class="title text-brand-1">Filtros</div>

    <section class="row q-gutter-sm text-brand-1 text-weight-bold">
      <div
        style="width: 24%"
        class="q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Unidade:
        <lista-unidades-select
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>
      <div
        style="width: 24%"
        class="q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Solicitante:
        <q-select
          dense
          outlined
          v-model="filtros.solicitante"
          :options="solicitanteOptions"
          option-label="name"
          use-input
          clearable
          hide-selected
          fill-input
          input-debounce="300"
          :loading="loadingSolicitante"
          @filter="filtrarSolicitante"
          @clear="filtros.solicitante = null"
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"
                >Nenhum resultado</q-item-section
              >
            </q-item>
          </template>
          <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.name }}</q-item-label>
                <q-item-label caption>{{ scope.opt.sap }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div
        style="width: 24%"
        class="q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Centro de Custo:
        <q-select
          dense
          outlined
          v-model="filtros.centro"
          :options="centroOptions"
          use-input
          clearable
          multiple
          input-debounce="300"
          :loading="loadingCentro"
          @filter="filtrarCentro"
          :display-value="
            filtros.centro && filtros.centro.length > 0
              ? filtros.centro[0].code +
                ' - ' +
                filtros.centro[0].name +
                (filtros.centro.length > 1 ? ' ...' : '')
              : ''
          "
        >
          <q-tooltip
            v-if="filtros.centro && filtros.centro.length > 1"
            anchor="top middle"
            self="bottom middle"
            class="bg-grey-8"
          >
            <div v-for="c in filtros.centro" :key="c.id">
              {{ c.code }} - {{ c.name }}
            </div>
          </q-tooltip>
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"
                >Nenhum resultado</q-item-section
              >
            </q-item>
          </template>
          <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label
                  >{{ scope.opt.code }} - {{ scope.opt.name }}</q-item-label
                >
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm text-brand-5 text-weight-bold filtro-item"
      >
        Função / GHE:
        <q-select
          dense
          outlined
          v-model="filtros.ghe"
          :options="gheOptions"
          use-input
          clearable
          multiple
          input-debounce="300"
          :loading="loadingGhe"
          @filter="filtrarGhe"
          :display-value="
            filtros.ghe && filtros.ghe.length > 0
              ? filtros.ghe[0].name + (filtros.ghe.length > 1 ? ' ...' : '')
              : ''
          "
        >
          <q-tooltip
            v-if="filtros.ghe && filtros.ghe.length > 1"
            anchor="top middle"
            self="bottom middle"
            class="bg-grey-8"
          >
            <div v-for="g in filtros.ghe" :key="g.id">{{ g.name }}</div>
          </q-tooltip>
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"
                >Nenhum resultado</q-item-section
              >
            </q-item>
          </template>
          <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.name }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
    </section>

    <section
      style="margin-top: 3px"
      class="row q-gutter-sm text-brand-1 text-weight-bold"
    >
      <div
        style="width: 24%"
        class="q-mt-sm q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Grupo Produto:
        <q-select
          dense
          outlined
          v-model="filtros.grupo"
          :options="grupoOptions"
          use-input
          clearable
          multiple
          input-debounce="300"
          :loading="loadingGrupo"
          @filter="filtrarGrupo"
          :display-value="
            filtros.grupo && filtros.grupo.length > 0
              ? filtros.grupo[0].name + (filtros.grupo.length > 1 ? ' ...' : '')
              : ''
          "
        >
          <q-tooltip
            v-if="filtros.grupo && filtros.grupo.length > 1"
            anchor="top middle"
            self="bottom middle"
            class="bg-grey-8"
          >
            <div v-for="g in filtros.grupo" :key="g.id">{{ g.name }}</div>
          </q-tooltip>
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"
                >Nenhum resultado</q-item-section
              >
            </q-item>
          </template>
          <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.name }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Produto:
        <q-select
          dense
          outlined
          v-model="filtros.produto"
          :options="produtoOptions"
          use-input
          clearable
          multiple
          input-debounce="300"
          :loading="loadingProduto"
          @filter="filtrarProduto"
          :display-value="
            filtros.produto && filtros.produto.length > 0
              ? filtros.produto[0].name +
                (filtros.produto.length > 1 ? ' ...' : '')
              : ''
          "
        >
          <q-tooltip
            v-if="filtros.produto && filtros.produto.length > 1"
            anchor="top middle"
            self="bottom middle"
            class="bg-grey-8"
          >
            <div v-for="p in filtros.produto" :key="p.id">{{ p.name }}</div>
          </q-tooltip>
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"
                >Nenhum resultado</q-item-section
              >
            </q-item>
          </template>
          <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.name }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm text-brand-5 text-weight-bold filtro-item"
      >
        Status:
        <q-select :options="tipos" v-model="filtros.status" dense outlined />
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm text-brand-5 text-weight-bold filtro-item"
      >
        Regra Critica:
        <q-select
          :options="regraOptions"
          v-model="filtros.regra"
          dense
          outlined
        />
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Turno:
        <q-select
          v-model="filtros.turnos"
          :options="turnoOptions"
          option-value="id"
          option-label="description"
          emit-value
          map-options
          multiple
          use-chips
          dense
          outlined
          clearable
          :loading="loadingTurnos"
          placeholder="Todos os turnos"
        >
          <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.description }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { watchDebounced } from "@vueuse/core";
import { useStore } from "vuex";
import { usuarioTemPermissao } from "../../../helpers/permissaoHelper";
export default {
  components: { ListaUnidadesSelect },
  setup(props, { emit }) {
    const filtros = ref({
      solicitante: null,
      centro: [],
      unidade: "",
      status: "",
      produto: [],
      grupo: [],
      ghe: [],
      regra: "",
      turnos: [],
    });
    const store = useStore();

    const temPermissaoTodosUsuarios = computed(() =>
      usuarioTemPermissao(store, "visualizar_todos_usuários")
    );

    const solicitanteOptions = ref([]);
    const centroOptions = ref([]);
    const gheOptions = ref([]);
    const grupoOptions = ref([]);
    const produtoOptions = ref([]);
    const turnoOptions = ref([]);

    const loadingSolicitante = ref(false);
    const loadingCentro = ref(false);
    const loadingGhe = ref(false);
    const loadingGrupo = ref(false);
    const loadingProduto = ref(false);
    const loadingTurnos = ref(false);

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      filtros.value.unidade = store.state.org.unidadeData;
    };
    onMounted(getUnidade);

    const getTurnos = async () => {
      loadingTurnos.value = true;
      try {
        const response = await store.dispatch("simplificadoStore/getTurnos", {
          vendor_id: filtros.value.unidade?.id,
        });
        turnoOptions.value = response.data.results || [];
      } catch (error) {
        console.error("Erro ao carregar turnos:", error);
      } finally {
        loadingTurnos.value = false;
      }
    };
    onMounted(getTurnos);

    const filtrarSolicitante = async (val, update) => {
      loadingSolicitante.value = true;
      try {
        const response = await store.dispatch("user/getUsuarios", {
          vendor_id: temPermissaoTodosUsuarios.value
            ? undefined
            : filtros.value.unidade?.id,
          search: val,
          per_page: 20,
          page: 1,
        });
        solicitanteOptions.value = response.data.results.data || [];
      } catch (error) {
        solicitanteOptions.value = [];
      } finally {
        loadingSolicitante.value = false;
        update();
      }
    };

    const filtrarCentro = async (val, update) => {
      loadingCentro.value = true;
      try {
        const response = await store.dispatch("user/getCentros", {
          vendor_id: filtros.value.unidade?.id,
          search: val,
          per_page: 20,
          page: 1,
        });
        centroOptions.value = response.data.results.data || [];
      } catch (error) {
        centroOptions.value = [];
      } finally {
        loadingCentro.value = false;
        update();
      }
    };

    const filtrarGhe = async (val, update) => {
      loadingGhe.value = true;
      try {
        const response = await store.dispatch("user/getFuncoes", {
          vendor_id: filtros.value.unidade?.id,
          search: val,
          per_page: 20,
          page: 1,
        });
        gheOptions.value = response.data.results.data || [];
      } catch (error) {
        gheOptions.value = [];
      } finally {
        loadingGhe.value = false;
        update();
      }
    };

    const filtrarGrupo = async (val, update) => {
      loadingGrupo.value = true;
      try {
        const response = await store.dispatch(
          "simplificadoStore/listarGrupoProdutos",
          {
            unidade: filtros.value.unidade?.id,
            search: val,
            per_page: 20,
          }
        );
        grupoOptions.value = response.data.results.data || [];
      } catch (error) {
        grupoOptions.value = [];
      } finally {
        loadingGrupo.value = false;
        update();
      }
    };

    const filtrarProduto = async (val, update) => {
      loadingProduto.value = true;
      try {
        const response = await store.dispatch(
          "simplificadoStore/listarGrupoProdutos",
          {
            unidade: filtros.value.unidade?.id,
            search: val,
            per_page: 20,
          }
        );
        produtoOptions.value = response.data.results.data || [];
      } catch (error) {
        produtoOptions.value = [];
      } finally {
        loadingProduto.value = false;
        update();
      }
    };

    watchDebounced(
      [
        () => filtros.value.solicitante,
        () => filtros.value.centro,
        () => filtros.value.unidade,
        () => filtros.value.status,
        () => filtros.value.produto,
        () => filtros.value.grupo,
        () => filtros.value.ghe,
        () => filtros.value.regra,
        () => filtros.value.turnos,
      ],
      () => {
        emit("emitirFiltros", filtros.value);
      },
      { debounce: 400 }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
        getTurnos();
      }
    );

    watch(
      () => filtros.value.unidade,
      () => {
        filtros.value.turnos = [];
        getTurnos();
      }
    );

    return {
      filtros,
      solicitanteOptions,
      centroOptions,
      gheOptions,
      grupoOptions,
      produtoOptions,
      turnoOptions,
      loadingSolicitante,
      loadingCentro,
      loadingGhe,
      loadingGrupo,
      loadingProduto,
      loadingTurnos,
      filtrarSolicitante,
      filtrarCentro,
      filtrarGhe,
      filtrarGrupo,
      filtrarProduto,
      tipos: [
        { label: "Todos", value: "" },
        { label: "Dentro do Prazo", value: "bloqueado" },
        { label: "Pode Trocar", value: "liberado" },
        { label: "Deve Trocar", value: "atrasado" },
        { label: "Nunca Retirado", value: "nunca_retirou" },
      ],
      regraOptions: [
        { label: "Todos", value: undefined },
        { label: "Sim", value: "critica" },
        { label: "Não", value: "nao_critica" },
      ],
    };
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 15px;
  font-size: 1.25rem;
  margin-top: 20px;
}

@media (max-width: 600px) {
  .title {
    font-size: 1.2rem !important;
    text-align: center;
    margin-bottom: 16px;
  }

  .filtro-item {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin: 0 0 16px 0 !important;
  }

  .filtro-item:last-child {
    margin: 0 0 16px 0 !important;
  }

  .filtro-item .q-field {
    width: 100% !important;
  }

  .filtro-item .q-select {
    width: 100% !important;
  }

  .row {
    flex-direction: column !important;
    gap: 0 !important;
  }
}
</style>
